(function () {
  'use strict';
  var initialized = window.__seoExperimentArticles || (window.__seoExperimentArticles = new WeakSet());
  function init(article) {
    if (initialized.has(article)) return;
    initialized.add(article);
    var context;
    try { context = JSON.parse(article.getAttribute('data-seo-context') || 'null'); } catch (_) { return; }
    var split = window.__seoSplitStates && window.__seoSplitStates.get(article);
    var bundle = split && split.bundle;
    var actualDigest = split && split.eligible ? split.contentDigest : article.dataset.contentDigest;
    if (!context || context.schemaVersion !== 1 || !context.enabled || context.origin !== location.origin ||
        context.pageId !== article.dataset.pageId || context.contentDigest !== (bundle ? bundle.context.contentDigest : article.dataset.contentDigest) ||
        !/^[a-f0-9]{64}$/.test(context.contextDigest) || !/^G-[A-Z0-9]+$/.test(context.measurementId) ||
        !/^[a-f0-9]{64}$/.test(context.contentDigest) || !['local', 'staging', 'production'].includes(context.environment) ||
        Boolean(context.experimentId) !== Boolean(context.armId) || Boolean(context.experimentId) !== Boolean(context.designDigest) ||
        !['gtag', 'gtm', 'shopify'].includes(context.transport) ||
        (context.environment !== 'production' && !context.allowTestStream) ||
        ((window.Shopify && window.Shopify.designMode) || /(?:preview_theme_id|preview_key)=/.test(location.search))) return;
    var seen = new Set(), timers = new Map(), visible = new Set();
    function allowed() {
      var now = Date.now(), privacy = window.Shopify && window.Shopify.customerPrivacy;
      try { return document.visibilityState !== 'hidden' && now >= Date.parse(context.startsAt) &&
        article.dataset.pageId === context.pageId && article.dataset.contentDigest === actualDigest &&
        (!context.endsAt || now < Date.parse(context.endsAt)) && privacy &&
        privacy.analyticsProcessingAllowed() === true &&
        (context.transport === 'shopify' || (window.seoAnalyticsConsent && window.seoAnalyticsConsent.analytics_storage === 'granted')); } catch (_) { return false; }
    }
    function send(name, extra, onceKey) {
      if (!allowed() || (onceKey && seen.has(onceKey))) return false;
      var payload = Object.assign({
        seo_page_id: context.pageId, seo_page_type: context.pageType,
        seo_publication_version: context.publicationVersionId, seo_content_digest: actualDigest,
        seo_context_digest: context.contextDigest, seo_environment: context.environment,
        seo_experiment_id: context.experimentId || undefined, seo_arm_id: context.armId || undefined,
        seo_design_digest: context.designDigest || undefined, seo_test: context.environment !== 'production',
        seo_direction_id: bundle ? bundle.directionId : undefined,
        seo_variant_id: bundle && split.eligible ? split.variantId : undefined,
        seo_comparison_id: bundle ? bundle.comparisonId : undefined,
        seo_deployment_id: bundle ? bundle.bundleDigest.slice(0, 24) : undefined,
        seo_cohort_eligible: bundle ? String(split.eligible === true) : undefined,
        page_location: location.origin + location.pathname,
      }, extra || {});
      try {
        if (context.transport === 'gtag') {
          if (typeof window.gtag !== 'function') return false;
          window.gtag('event', name, Object.assign(payload, { send_to: context.measurementId, transport_type: 'beacon' }));
        } else if (context.transport === 'gtm') {
          if (!Array.isArray(window.dataLayer)) return false;
          window.dataLayer.push(Object.assign(payload, { event: name, seo_measurement_id: context.measurementId }));
        } else {
          if (!window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
          Promise.resolve(window.Shopify.analytics.publish('seo_' + name.replace(/^seo_/, ''), payload)).catch(function () {});
        }
        if (onceKey) seen.add(onceKey);
        return true;
      } catch (_) { return false; }
    }
    function list(card) {
      var block = card.closest('.seo-products');
      return { item_list_id: context.pageId + ':' + block.id, item_list_name: block.id, seo_block_id: block.id };
    }
    function item(card) {
      return { item_id: (context.itemIdFormat === 'gid' ? 'gid://shopify/Product/' : '') + card.dataset.seoItem,
        item_name: card.dataset.seoItemName, index: Number(card.dataset.seoPosition) };
    }
    function expose(card) {
      if (!context.ownsProductEvents || !visible.has(card) || timers.has(card)) return;
      timers.set(card, setTimeout(function () {
        timers.delete(card);
        if (visible.has(card)) send('view_item_list', Object.assign(list(card), { items: [item(card)] }), 'exposure:' + card.closest('.seo-products').id + ':' + card.dataset.seoPosition);
      }, 1000));
    }
    function refresh() {
      send('seo_page_view', {}, 'page');
      if (bundle) {
        if (split.eligible) send('seo_experiment_assignment', { seo_intended_variant: split.intendedVariantId }, 'assignment');
        else send('seo_experiment_fallback', { seo_fallback_reason: split.reason || 'unknown', seo_intended_variant: split.intendedVariantId }, 'fallback');
        if (typeof requestAnimationFrame === 'function') requestAnimationFrame(function () { exposure(); });
      }
      visible.forEach(expose);
    }
    function isVisible(element) {
      if (!element || article.style.visibility === 'hidden') return false;
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
    }
    function exposure(target) {
      if (!bundle || !split.eligible || !isVisible(target || article.querySelector('h1'))) return false;
      return seen.has('variant-exposure') || send('seo_experiment_exposure', {}, 'variant-exposure');
    }
    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { visible.add(entry.target); expose(entry.target); }
          else { visible.delete(entry.target); clearTimeout(timers.get(entry.target)); timers.delete(entry.target); }
        });
      }, { threshold: [0, 0.5] });
      article.querySelectorAll('[data-seo-item]').forEach(function (card) { observer.observe(card); });
      if (bundle && article.querySelector('h1')) {
        var exposureObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; }) && typeof requestAnimationFrame === 'function') requestAnimationFrame(function () { exposure(); });
        });
        exposureObserver.observe(article.querySelector('h1'));
      }
    }
    article.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target.closest('a') : null;
      if (!target || !article.contains(target)) return;
      var card = target.closest('[data-seo-item]');
      var qualifiedAction = card || target.classList.contains('seo-cta-button');
      if (qualifiedAction && exposure(target)) send('seo_experiment_engaged', {}, 'variant-engaged');
      if (card && context.ownsProductEvents) send('select_item', Object.assign(list(card), { items: [item(card)] }));
      if (target.classList.contains('seo-cta-button')) send('seo_cta_click', { seo_block_id: target.closest('section').id });
    });
    article.querySelectorAll('.seo-faq details').forEach(function (details, index) {
      details.addEventListener('toggle', function () {
        if (details.open) send('seo_faq_open', { seo_block_id: details.closest('section').id, seo_faq_position: index + 1 }, 'faq:' + index);
      });
    });
    document.addEventListener('visitorConsentCollected', refresh);
    document.addEventListener('seo:consent-changed', refresh);
    document.addEventListener('seo:transport-ready', refresh);
    document.addEventListener('visibilitychange', refresh);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) refresh(); });
    }
    refresh();
  }
  document.querySelectorAll('article[data-seo-context]').forEach(function (article) { try { init(article); } catch (_) {} });
}());
